
<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout wrap px-md-4>
      <v-flex md8 pr-md-3 pr-2 style="border-right: 1px solid #808080">
        <v-layout wrap pt-5>
          <v-flex md3 lg4>
            <div class="RM clr">SELLER PORTAL</div>
            <div class="head">Analytics</div>
          </v-flex>
          <v-flex md9 lg8>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-card tile flat color="#F5F7FC">
                  <v-layout wrap pa-5 pa-lg-5>
                    <v-flex xs12 class="small">Daily Visitors </v-flex>
                    <v-flex xs6 class="RB">{{
                      statisticsCount.dailyVisitors
                    }}</v-flex>
                    <v-flex v-if="statisticsCount.dailyVisitors_percent > 0"
                      align-self-center
                      s6
                      style="color: #3dc131; font-size: 10px"
                      >
                       <span> <v-icon x-samll color="#3dc131" >
                          mdi-arrow-up</v-icon
                          ></span> <span> {{ statisticsCount.dailyVisitors_percent }}% </span>
                           </v-flex>
                    <v-flex v-else
                      align-self-center
                      s6
                      style="color:red; font-size: 10px"
                      > <span> <v-icon x-small color="red" >
                          mdi-arrow-down</v-icon
                          ></span> <span> {{ valueformat(statisticsCount.dailyVisitors_percent) }}% </span>
                           </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md4 px-md-2 py-3 py-md-0>
                <v-card tile flat color="#F5F7FC">
                  <v-layout wrap pa-5>
                    <v-flex xs12 class="small">Avg. Order / Day </v-flex>
                    <v-flex xs6 class="RB">{{
                      statisticsCount.averageOrders
                    }}</v-flex>
                    <v-flex
                      align-self-center
                      v-if="statisticsCount.averageOrders_percent > 0"
                      xs6
                      style="color: #3dc131; font-size: 10px"
                    >
                      <span
                        >
                        <v-icon x-samll color="#3dc131" >
                          mdi-arrow-up</v-icon
                          >
                          </span
                      >
                      <span>
                        {{ statisticsCount.averageOrders_percent }}%
                      </span>
                      </v-flex>
                    <v-flex
                      align-self-center
                      v-else
                      xs6
                      style="color: red; font-size: 10px"
                    >
                      <span
                        ><v-icon x-small color="red"
                          >mdi-arrow-down</v-icon
                        ></span
                      >
                      <span>
                        {{ valueformat(statisticsCount.averageOrders_percent)}}%
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex md4>
                <v-card tile flat color="#F5F7FC">
                  <v-layout wrap pa-5>
                    <v-flex xs12 class="small">Total Orders </v-flex>
                    <v-flex xs6 class="RB">{{
                      statisticsCount.totalOrders
                    }}</v-flex>

                    <v-flex
                      align-self-center
                      v-if="statisticsCount.totalOrders_percent > 0"
                      xs6
                      style="color: #3dc131; font-size: 10px"
                    >
                      <span
                        ><v-icon x-samll color="#3dc131"
                          >mdi-arrow-up</v-icon
                        ></span
                      >
                      <span> {{statisticsCount.totalOrders_percent}}% </span>
                      <!-- <span>{{valueformat(-20)}}</span> -->
                    </v-flex>
                    <v-flex
                      align-self-center
                      v-else
                      xs6
                      style="color: red; font-size: 10px"
                    >
                      <span
                        ><v-icon x-small color="red"
                          >mdi-arrow-down</v-icon
                        ></span
                      >
                      <span> {{  valueformat (statisticsCount.totalOrders_percent) }}%</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="opensans clr" pt-3>
            Total Sales This Year
          </v-flex>
          <v-flex xs12>
            <v-layout wrap class="opensans">
              <v-flex md4 align-self-start style="font-size: 18px">
                ₹ {{ statisticsCount.totalSales }}
              </v-flex>
              <!-- <v-flex md6 align-self-start style="font-size: 14px; color: green"
                >{{ seris.data[0] }}
              </v-flex> -->
              <v-flex md8 text-right>
                <v-select text solo flat :items="years" v-model="year">
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-if="flag">
            <apexchart
              width="100%"
              height="400px"
              type="line"
              :options="options"
              :series="series"
            >
            </apexchart>
          </v-flex>
          <v-flex xs12 py-5>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs6 class="RB clr" py-3 py-lg-0 v-if="top.length > 0" >Top Selling Products </v-flex>
          <v-flex xs6 text-right py-3 py-lg-0 v-if="top.length > 0">
            <router-link :to="(path = '/topSelling')"
              style="text-decoration: none">
            <v-btn rounded outlined>VIEW All </v-btn>
            </router-link>
          </v-flex>
          <v-flex xs12>
            <v-card flat >
              <v-layout wrap v-for="(item, i) in top" :key="i" py-2>
                <v-flex xs12 sm2 md2 pb-3 pb-md-0>
                  <v-img  v-if="item.product.photos[0].length < 1"
                    height="80px"
                    cover
                    src="../../../assets/images/m1.png"
                  >
                  </v-img>
                  <v-img v-else
                    height="80px"
                    contain
                    :src="mediaURL +item.product.photos[0]"
                  >
                  </v-img>
                </v-flex>
                <v-flex pl-1 xs10 align-self-center>
                  <v-layout wrap pl-lg-3>
                    <v-flex xs7 sm5 md6>
                      <div class="medium clr RG">{{item.product.productName}}</div>
                      <div class="RB medium">Price: ₹{{item.product.price}} per Kg</div>
                    </v-flex>
                    <v-flex xs5 sm3 md2>
                      <div class="medium clr RG">Sold Quantity</div>
                      <div class="RB medium">{{item.soldQuantity}}KG</div>
                    </v-flex>
                    <v-flex xs6 sm2 md2 pt-3 pt-sm-0 pt-md-0>
                      <div class="medium clr RG">Today</div>
                      <div class="RB medium">₹{{item.todaySale}} /-</div>
                    </v-flex>
                    <v-flex xs6 sm2 md2 pt-3 pt-sm-0 pt-md-0>
                      <div class="medium clr RG">Total Sale</div>
                      <div class="RB medium">₹{{item.totalSale}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pt-4>
                  <v-divider> </v-divider>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md4 pl-3 v-if="preOrderList.length > 0">
        <v-layout wrap pt-6 >
          <v-flex xs6 md8>Previous Customer Orders </v-flex>
          <v-flex xs6 md4 text-right>
            <router-link
              :to="(path = '/previousOrder')"
              style="text-decoration: none"
            >
              <v-btn rounded outlined dense> View all </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout wrap v-for="(item, i) in preOrderList" :key="i" py-3>
          <v-flex xs12 lg10 >
            <v-card flat>
              <v-layout wrap>
                <v-flex xs3>
                  <v-img
                    height="80px"
                    :src="mediaURL + item.productId.photos[0]"
                  >
                  </v-img>
                </v-flex>
                <v-flex xs9 pl-2 pl-lg-3>
                  <v-layout wrap fill-height>
                    <v-flex xs12 class="RM clr">{{ item.name }}</v-flex>
                    <v-flex xs8 class="regulartext"
                      >Price: ₹ {{ item.price }}
                    </v-flex>
                    <v-flex xs4 class="regulartext"
                      >{{ item.quantity }} kg
                    </v-flex>

                    <v-flex xs8 class="RM medium"
                      >{{ item.productOrderStatus }}
                    </v-flex>
                    <v-flex xs4 class="regulartext">
                      <span v-html="DateFormatted(item.order_date)"></span>
                    </v-flex>
                    <v-flex
                      xs12
                      align-self-end
                      class="regulartext"
                      style="color: #42af54; font-size: 12px"
                      >Stock: {{ item.productId.stockQuantity }} Kg
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      top:[],
      todaysale:"",
      totalsale:"",
      year: "",
      years: ["2021", "2022", "2023", "2024", "2025"],
      ServerError: false,
      appLoading: false,
      preOrderList: [],
      graphData: [],
      statisticsCount: [],
      flag: false,
      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "sales",
          data: [],
        },
      ],
    };
  },
  watch: {
    year() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.orderList();
    this.topProduct();
  },
  methods: {
    
    valueformat(a)
    {
      return Math.abs(a);
    },
    
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
    getData() {
      this.appLoading = true;
      this.flag = false;
      this.options.xaxis.categories = [];
      this.series[0].data = [];

      axios({
        method: "post",
        url: "/seller/analytics",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          year1: this.year,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.graphData = response.data.grapth;
            for (let i = 0; i < response.data.graph.length; i++) {
              this.options.xaxis.categories.push(
                response.data.graph[i].month_shrt
              );
              this.series[0].data.push(response.data.graph[i].sales);
            }
            this.flag = true;
            this.statisticsCount = response.data.statisticsCount;
          }
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    orderList() {
      this.appLoading =true;
      axios({
        method: "post",
        url: "/seller/ordered/products/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data:
        {
          count:6
        }
      })
        .then((response) => {
          if (response.data.status) {
           
              this.preOrderList = response.data.data ;
          }
          this.appLoading =false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    topProduct()
    {
      this.appLoading =true;
       axios({
        method: "post",
        url: "/seller/topselling/products/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        count:2
      })
      .then((response) =>{

        if(response.data.status)
        {
        
        this.top = response.data.data
           
      
        }
         this.appLoading =false;
      })
      .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    }
  },
};
</script>

